import { getGradingTypeLabel } from "../utils/gradingTypes";

export const normalizePackageItems = (productPackageOrItems) => {
  if (Array.isArray(productPackageOrItems)) {
    return productPackageOrItems;
  }
  if (Array.isArray(productPackageOrItems?.items) && productPackageOrItems.items.length) {
    return productPackageOrItems.items;
  }
  if (productPackageOrItems?.gradingType || productPackageOrItems?.numberOfCards) {
    return [{
      gradingType: productPackageOrItems.gradingType,
      numberOfCards: productPackageOrItems.numberOfCards,
      autographEvaluation: Boolean(productPackageOrItems.autographEvaluation),
    }];
  }
  return [];
};

export const totalPackageCards = (items) => (
  normalizePackageItems(items).reduce((sum, item) => sum + Number(item.numberOfCards || 0), 0)
);

export const formatPackageItemsSummary = (items) => {
  const lines = normalizePackageItems(items);
  if (!lines.length) {
    return "";
  }
  return lines
    .map((item) => {
      const label = getGradingTypeLabel(item.gradingType) || item.gradingType;
      const cards = Number(item.numberOfCards) || 0;
      const auto = item.autographEvaluation ? " + autógrafo" : "";
      return `${cards}× ${label}${auto}`;
    })
    .join(" + ");
};
